import { AlgomerchTag } from "../../flights/shopping";
export function getFlightGridFares(tripFares, outgoingRating, isReturn, rewardsKey) {
    // TODO create currency mapping function
    var fares = {
        basic: null,
        standard: null,
        premium: null,
        enhanced: null,
        luxury: null,
    };
    var filteredFares = outgoingRating != undefined
        ? tripFares.filter(function (f) { var _a; return ((_a = f.fareShelf) === null || _a === void 0 ? void 0 : _a.outgoing.rating) === outgoingRating; })
        : tripFares;
    filteredFares.forEach(function (fare) {
        var _a, _b, _c;
        var fareShelf = isReturn
            ? (_a = fare.fareShelf) === null || _a === void 0 ? void 0 : _a.returning
            : (_b = fare.fareShelf) === null || _b === void 0 ? void 0 : _b.outgoing;
        var tags = getTags(fare.fareScore);
        var reward = fare.amount.rewards[rewardsKey !== null && rewardsKey !== void 0 ? rewardsKey : ""];
        var gridFare = {
            fareId: fare.fareId,
            fareName: (_c = fareShelf === null || fareShelf === void 0 ? void 0 : fareShelf.shortBrandName) !== null && _c !== void 0 ? _c : "",
            price: "".concat(fare.amount.fiat.currencySymbol).concat(Math.round(fare.amount.fiat.value)),
            rawPrice: fare.amount.fiat.value,
            tags: tags,
        };
        if (reward) {
            // TODO: possibly move getRewardText and other Prices related helpers to Redmond
            var isFiatCurrency = reward.currency === "$";
            var formattedValue = isFiatCurrency
                ? reward.value.toFixed(2)
                : Math.ceil(reward.value).toLocaleString();
            gridFare["reward"] = isFiatCurrency
                ? "".concat(reward.currency).concat(formattedValue)
                : "".concat(formattedValue, " ").concat(reward.currencyDescription || reward.currency);
        }
        switch (fareShelf === null || fareShelf === void 0 ? void 0 : fareShelf.rating) {
            case 0:
                fares.basic = gridFare;
                break;
            case 1:
                fares.standard = gridFare;
                break;
            case 2:
                fares.enhanced = gridFare;
                break;
            case 3:
                fares.premium = gridFare;
                break;
            case 4:
                fares.luxury = gridFare;
                break;
        }
    });
    return fares;
}
export var getHopperFareRatingName = function (rating) {
    switch (rating) {
        case 0:
            return "BasicEconomy";
        case 1:
            return "Economy";
        case 2:
            return "PremiumEconomy";
        case 3:
            return "Business";
        case 4:
            return "First";
        default:
            return "";
    }
};
export function getTags(fareScore) {
    var tags = [];
    if (fareScore.isCheapest) {
        tags.push(AlgomerchTag.Cheapest);
    }
    if (fareScore.isFastest) {
        tags.push(AlgomerchTag.Fastest);
    }
    if (fareScore.isBest) {
        tags.push(AlgomerchTag.BestFlight);
    }
    if (fareScore.isBestQuality) {
        tags.push(AlgomerchTag.BestQuality);
    }
    return tags;
}
export var mapAlgomerchTexts = {
    BestFlight: "Best Overall",
    Cheapest: "Best Price",
    BestQuality: "Best Quality",
    Fastest: "Fastest",
};
export var isSouthwestAirlines = function (airlineCode) {
    return airlineCode === "WN";
};
//# sourceMappingURL=trip-summary.js.map